import cx from "classnames";
import React from "react";
import * as css from "./ExcerptDetails.module.css";

type Props = {
  tags: Queries.Maybe<string | undefined>;
};

export function Tags(props: Props) {
  if (!props.tags) return null;

  const tags = props.tags.split(",").map((t) => t.trim());

  return (
    <div className={css.tagList}>
      {tags.map((tag) => (
        <span
          className={cx(css.label, css[tag.toLowerCase().replace(" ", "")])}
          key={tag}
        >
          {tag.toUpperCase()}
        </span>
      ))}
    </div>
  );
}

type TopProps = Props & {
  timeToRead?: Queries.Maybe<number | undefined>;
};

export default function ExcerptDetails(props: TopProps) {
  return (
    <div className={css.top}>
      <Tags tags={props.tags} />
      <div className={css.timeToRead}>{props.timeToRead} min read</div>
    </div>
  );
}
